import PropTypes from 'prop-types';
//material-ui
import { styled } from '@mui/material/styles';

// third-party
import {MaterialDesignContent, SnackbarProvider} from 'notistack';

// project imports
import Loader from 'components/Loader';
import { useGetSnackbar } from 'api/snackbar';

// assets
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import React, {useContext, useEffect} from "react";
import {NotificationContext} from "@/contexts/NotificationProvider";
import { IconButton } from '@mui/material'; // Assicurati di avere MUI installato
import { CloseOutlined } from '@ant-design/icons'; // O l'icona che preferisci
import { closeSnackbar } from 'notistack';

// custom styles
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  '&.notistack-MuiContent-default': {
    background: theme.palette.primary.main
  },
  '&.notistack-MuiContent-error': {
    background: theme.palette.error.main
  },
  '&.notistack-MuiContent-success': {
    background: theme.palette.success.main
  },
  '&.notistack-MuiContent-info': {
    background: theme.palette.info.main
  },
  '&.notistack-MuiContent-warning': {
    background: theme.palette.warning.main
  }
}));


const NotistackRegister = React.forwardRef((props, ref) => {
    const { message } = props;
    const { addNotification } = useContext(NotificationContext);

    useEffect(() => {
        if (message && typeof message === 'string') {
            const notification = {name: message, date: (new Date()).toLocaleString('it-IT')}
            addNotification(notification);
        }
    }, [message]);

    return (
        <MaterialDesignContent
            ref={ref}
            {...props}
            style={{ cursor: 'pointer' }}
        />
    );
});

NotistackRegister.displayName = 'NotistackRegister';

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

export default function Notistack({ children, ...others }) {
  const { snackbar } = useGetSnackbar();
  const iconSX = { marginRight: 8, fontSize: '1.15rem' };

  if (snackbar === undefined) return <Loader />;

  const action = (snackbarId) => (
    <IconButton 
      size="small" 
      onClick={() => closeSnackbar(snackbarId)} 
      style={{ color: 'inherit' }}
    >
      <CloseOutlined style={{ fontSize: '12px' }} />
    </IconButton>
  );

  return (
    <StyledSnackbarProvider
      maxSnack={snackbar.maxStack}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      dense={snackbar.dense}
      {...others}
      
      action={(snackbarId) => action(snackbarId)}

      Components={{
          default: NotistackRegister,
          success: NotistackRegister,
          error: NotistackRegister,
          warning: NotistackRegister,
          info: NotistackRegister
      }}
      iconVariant={
        snackbar.iconVariant === 'useemojis'
          ? {
              success: <CheckCircleOutlined style={iconSX} />,
              error: <CloseCircleOutlined style={iconSX} />,
              warning: <WarningOutlined style={iconSX} />,
              info: <InfoCircleOutlined style={iconSX} />
            }
          : undefined
      }
      hideIconVariant={snackbar.iconVariant === 'hide'}
    >
      {children}
    </StyledSnackbarProvider>
  );
}

Notistack.propTypes = {
    children: PropTypes.any,
    autoHideDuration: PropTypes.number,
    onClick: PropTypes.func
};
